import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGarage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="garage"><path fillRule="evenodd" clipRule="evenodd" d="M10.0411 3.57052C11.2432 2.83408 12.7568 2.83408 13.9589 3.57052L20.2089 7.39935C21.3216 8.08101 22 9.2921 22 10.597V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V10.597C2 9.2921 2.67835 8.08101 3.79107 7.39935L10.0411 3.57052ZM7.5 18.5H16.5V16H7.5V18.5ZM7.5 14.5H16.5V14.25C16.5 13.0074 15.4926 12 14.25 12H9.75C8.50736 12 7.5 13.0074 7.5 14.25V14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconGarage;
